import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { WhatsAppButton } from "@/components/ui/WhatsAppButton";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import About from "@/pages/About";
import SEO from "@/pages/SEO";
import PayPerClick from "@/pages/PayPerClick";
import SocialMediaManagement from "@/pages/SocialMediaManagement";
import FacebookAds from "@/pages/FacebookAds";
import WebDesign from "@/pages/WebDesign";
import AiSeo from "@/pages/AiSeo";
import Contact from "@/pages/Contact";
import Testimonials from "@/pages/Testimonials";
import ThankYou from "@/pages/ThankYou";
import PrivacyCookiesPolicy from "@/pages/PrivacyCookiesPolicy";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/index.html" component={Home} />
      <Route path="/company.html" component={About} />
      <Route path="/search-engine-optimisation.html" component={SEO} />
      <Route path="/ai-seo.html" component={AiSeo} />
      <Route path="/pay-per-click-management.html" component={PayPerClick} />
      <Route path="/social-media-management.html" component={SocialMediaManagement} />
      <Route path="/facebook-advertising.html" component={FacebookAds} />
      <Route path="/web-design.html" component={WebDesign} />
      <Route path="/testimonials.html" component={Testimonials} />
      <Route path="/contact.html" component={Contact} />
      <Route path="/thank-you.html" component={ThankYou} />
      <Route path="/privacy-cookies-policy.html" component={PrivacyCookiesPolicy} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Router />
          <WhatsAppButton />
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
